// FROM: https://github.com/modusign/modusign-client/blob/1f2cc00e317b3cc6ddf42ace319c72036470a423/app/src/containers/FieldRenderers/ProgressFieldRenderers/CheckboxGroup/index.tsx

import { Box, Flex, Text } from '@modusign/design-system';

import {
  AbsolutePoint,
  AbsoluteSize,
} from '@app/features/apply-react-signing/components/FieldRenderer/types';
import orderRotationForColor from '@app/libs/participantFields/orderRotationForColor';
import CheckboxGroupInputMode from '@app/store/CheckboxGroupInputMode';

interface CheckboxGroupBorderProps {
  point: AbsolutePoint;
  size: AbsoluteSize;
  checkboxFieldCount: number;
  mode: CheckboxGroupInputMode;
  participantOrder: number;
  required: boolean;
  visible: boolean;
}

export const CHECKBOX_GROUP_BORDER_MARGIN_PX = 14;

export default function CheckboxGroupBorder({
  point,
  size,
  checkboxFieldCount,
  mode,
  participantOrder,
  required,
  visible,
}: CheckboxGroupBorderProps) {
  const { x, y } = point;
  const { width, height } = size;

  return (
    <>
      {visible && checkboxFieldCount > 1 ? (
        <Flex
          backgroundColor="statusBackgroundNeutralDarkest"
          borderRadius="4px"
          color="white"
          flexDirection="column"
          fontStyle="normal"
          height="23px"
          justifyContent="center"
          padding="2px 6px 3px"
          position="absolute"
          style={{
            transform: `translate(${x - CHECKBOX_GROUP_BORDER_MARGIN_PX / 2}px, ${
              y + height + CHECKBOX_GROUP_BORDER_MARGIN_PX / 2 + 4
            }px)`,
          }}
          textAlign="center"
          width="68px"
          zIndex={111}
        >
          <Text fontSize="xs" fontWeight="medium">
            {mode === 'RADIO' ? '하나만 선택' : '여러개 선택'}
          </Text>
        </Flex>
      ) : null}
      <Box
        backgroundColor="transparent"
        borderColor={`participantOrder${orderRotationForColor(participantOrder)}`}
        position="absolute"
        style={{
          transform: `translate(${x - CHECKBOX_GROUP_BORDER_MARGIN_PX / 2}px, ${
            y - CHECKBOX_GROUP_BORDER_MARGIN_PX / 2
          }px)`,
          height: `${height + CHECKBOX_GROUP_BORDER_MARGIN_PX}px`,
          width: `${width + CHECKBOX_GROUP_BORDER_MARGIN_PX}px`,
        }}
        zIndex={100}
      >
        {required ? (
          <Box
            color="red"
            data-testid="checkbox-group-required"
            fontSize={17}
            left={-10}
            position="absolute"
            top="-1px"
          >
            *
          </Box>
        ) : null}

        <Box
          border="2px dashed"
          borderColor={`participantOrder${orderRotationForColor(participantOrder)}`}
          borderRadius="3px"
          data-testid="checkbox-group-border"
          display={visible ? 'block' : 'none'}
          height="100%"
          width="100%"
        />
      </Box>
    </>
  );
}
